export enum PendingInviteBulkResultStatus {
  Invited = 'invited',
  Resent = 'resent',
  Added = 'added',
  AlreadyAdded = 'alreadyAdded',
  Failed = 'failed',
}

export class PendingInviteBulkResultDto {
  userEmail: string;
  status: PendingInviteBulkResultStatus;
  message?: string;
}

export class PendingInviteBulkAddResponseDto {
  results: PendingInviteBulkResultDto[];
}
